export default {
    methods: {
        formatPrice(price) {
            if (isNaN(price)) {
                return 0;
            }
            return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL'}).format((price / 100).toFixed(2))
        }
    }
}
